var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5667 8.0035C12.967 7.27425 11.2279 6.89739 9.46745 6.90004L9.4667 6.90004C7.64709 6.90004 5.91992 7.29629 4.3667 8.00365V22.913C5.98071 22.2428 7.71391 21.8976 9.4667 21.9L14.5667 8.0035ZM14.5667 8.0035V19.2C14.5667 19.757 14.7879 20.2911 15.1818 20.685C15.5756 21.0788 16.1097 21.3 16.6667 21.3C17.2237 21.3 17.7578 21.0788 18.1516 20.685C18.5454 20.2911 18.7667 19.757 18.7667 19.2V8.00365C20.3199 7.29629 22.0471 6.90004 23.8667 6.90004L23.8674 6.90004C25.6279 6.89739 27.367 7.27425 28.9667 8.0035V22.9133M14.5667 8.0035L28.9667 22.9133M28.9667 22.9133C27.396 22.2615 25.6728 21.9001 23.8669 21.9C23.8671 21.9 23.8673 21.9 23.8675 21.9L28.9667 22.9133ZM16.6668 24.0159C14.5914 22.6756 12.1196 21.9001 9.46707 21.9C9.46719 21.9 9.46731 21.9 9.46744 21.9L16.6668 24.0159Z",
    fill: "#8F03ED",
    stroke: "#8F03ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book_open.04a981afac786cb96c75d7753f191fbe.svg";
export { ForwardRef as ReactComponent };